<template>
  <div>
    <div class="vx-row">
        <div class="vx-col w-full">
            <template v-if="userData">
                <!-- DATOS DEL USUARIO SI ES PERSONA FISICA -->
                <div v-if="userData.personal_profile_data">
                    <label class="bold text-success">PERSONAL PROFILE</label>
                    <vs-list>
                        <vs-list-item title="ID">
                          <update-attribute :edit-enabled="editEnabled" object-db="users" field-option="personal_profile_id" :field-data="userData.personal_profile_data.id" @updated="dataUpdated" />                      
                        </vs-list-item>
                        <vs-list-item title="RFC">
                          <update-attribute :delete-enabled="true" object-db="personal_profiles" field-option="rfc" :field-data="userData.personal_profile_data.rfc" @updated="dataUpdated"/>                      
                        </vs-list-item>
                        <vs-list-item title="CURP">
                          <update-attribute :delete-enabled="true" object-db="personal_profiles" field-option="curp" :field-data="userData.personal_profile_data.curp" @updated="dataUpdated"/>
                        </vs-list-item>
                        <vs-list-item title="VERIFICACIÓN DE IDENTIDAD">{{userData.personal_profile_data.identity_verification_status}}</vs-list-item>
                    </vs-list>
                </div>
                <!-- DATOS DEL USUARIO SI ES PERSONA MORAL -->
                <div v-if="userData.business_profile_data">
                    <label class="bold text-success">BUSINESS PROFILE</label>
                    <vs-list>
                        <vs-list-item title="ID">
                          <update-attribute :edit-enabled="editEnabled" object-db="users" field-option="business_profile_id" :field-data="userData.business_profile_data.id" @updated="dataUpdated"/>
                        </vs-list-item>
                        <vs-list-item title="RFC">
                          <update-attribute :delete-enabled="true" object-db="business_profiles" field-option="rfc" :field-data="userData.business_profile_data.rfc" @updated="dataUpdated"/>
                        </vs-list-item>
                        <vs-list-item title="REPRESENTANTE LEGAL">
                          {{ userData.business_profile_data.legal_representative_name }}
                        </vs-list-item>
                    </vs-list>
                    <!-- DATOS DEL REPRESENTANTE LEGAL -->
                    <div v-if="userData.business_profile_data.legal_representative_data">
                        <label class="bold text-success">REPRESENTANTE LEGAL</label>
                        <vs-list>
                        <vs-list-item title="ID">
                          <update-attribute object-db="business_profiles" field-option="personal_profile_id" :field-data="userData.business_profile_data.legal_representative_data.personal_profile_id" @updated="dataUpdated"/>
                        </vs-list-item>
                        <vs-list-item title="RFC">
                          <update-attribute :delete-enabled="true" object-db="personal_profiles" field-option="rfc" :field-data="userData.business_profile_data.legal_representative_data.rfc" @updated="dataUpdated"/>                      
                        </vs-list-item>
                        <vs-list-item title="CURP">
                          <update-attribute :delete-enabled="true" object-db="personal_profiles" field-option="curp" :field-data="userData.business_profile_data.legal_representative_data.curp" @updated="dataUpdated"/>
                        </vs-list-item>
                        <vs-list-item title="VERIFICACIÓN DE IDENTIDAD">{{userData.business_profile_data.legal_representative_data.identity_verification_status}}</vs-list-item>
                        </vs-list>                              
                    </div>
                </div>
            </template>
        </div>
    </div>
  </div>
</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import UpdateAttribute from '@components/forms/UpdateAttribute.vue';

export default  {
  name: 'person-type-data',
  props: {
    userData: {
      required: true
    }
  },
  mixins: [formatHelper],
  components: {UpdateAttribute},
  data() {
    return {

    }
  },
  computed:{
		editEnabled(){
      return this.userData.user_id != null;
    }
  },
  methods: {
    async dataUpdated() {
      await this.$emit("updated");
    },
  }
}
</script>